import { Injectable, inject } from '@angular/core';
import { GeoBrowserService, MapColors, InteractionService } from '@next/arable-lib/geo';
import { select, Store } from '@ngrx/store';
import { GeoJSON } from 'ol/format';
import VectorLayer from 'ol/layer/Vector';
import { Vector } from 'ol/source';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SiteState } from 'src/app/shared/models';

import { getCropFieldsLayerEnabled, getFeatures } from '../store/map.selectors';

@Injectable({
  providedIn: 'root',
})
export class GeoSelectCropFieldService implements InteractionService {
  private readonly store = inject<Store<SiteState>>(Store);

  readonly source = new Vector({
    wrapX: false,
  });

  readonly style = new Style({
    fill: new Fill({
      color: MapColors.viewFill,
    }),
    stroke: new Stroke({
      color: MapColors.viewStroke,
      width: 1.5,
    }),
  });

  readonly defilteredStyle = new Style({
    fill: new Fill({
      color: MapColors.defilteredViewFill,
    }),
  });

  private _layer: VectorLayer | null = null;

  get layer(): VectorLayer {
    if (!this._layer) {
      this._layer = new VectorLayer({
        source: this.source,
        style: (_) => this.getStyle(),
        zIndex: 2,
      });
    }
    return this._layer;
  }

  private reader = new GeoJSON({});
  private destroyed$!: ReplaySubject<boolean>;

  init(geoService: GeoBrowserService): void {
    this.destroyed$ = new ReplaySubject<boolean>(1);

    if (this._layer) {
      try {
        this._layer.getSource();
      } catch {
        this._layer = null;
      }
    }

    if (!geoService.map.getLayers().getArray().includes(this.layer)) {
      geoService.map.addLayer(this.layer);
    }

    this.store.pipe(select(getFeatures), takeUntil(this.destroyed$)).subscribe((features) => {
      this.source.clear();
      features.forEach((f) => {
        const feature = this.reader.readFeature(f);
        feature.setId(f.id);
        this.source.addFeature(feature);
      });
    });

    this.store
      .pipe(select(getCropFieldsLayerEnabled), takeUntil(this.destroyed$))
      .subscribe((enabled) => {
        this.layer.setVisible(enabled);
      });
  }

  start(_: GeoBrowserService): void { }

  stop(_: GeoBrowserService): void { }

  getStyle() {
    return this.style;
  }
  destroy(geoService?: GeoBrowserService) {
    if (geoService && this._layer && geoService.map.getLayers().getArray().includes(this._layer)) {
      geoService.map.removeLayer(this._layer);
      this._layer.dispose();
    }
    this._layer = null;
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
